import { useContext, useEffect } from 'react';
import ActiveNavContext from '@/context/ActiveNavContext';

// Marks `key` as the active sidebar option while the calling screen is mounted.
const useActiveNavKey = (key?: string) => {
  const setActiveNavKey = useContext(ActiveNavContext)?.setActiveNavKey;

  useEffect(() => {
    if (!setActiveNavKey) return undefined;
    setActiveNavKey(key);
    return () => setActiveNavKey(undefined);
  }, [key, setActiveNavKey]);
};

export const useActiveNavKeyValue = () => useContext(ActiveNavContext)?.activeNavKey;

export default useActiveNavKey;
